import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DataStateChangeEventArgs, GridComponent, PageSettingsModel } from '@syncfusion/ej2-angular-grids';
import { Observable, Subject } from 'rxjs';
import { GetListNewBO, saveListBO } from '../list/list.model';
import { ListDateService } from '../list/listdateservice';
import { GlobalComponent } from 'src/app/global/global.component';
import { ToastrService } from 'ngx-toastr';
import { ListService } from '../list/list.service';

import { takeUntil } from 'rxjs/operators';
import { ColorNoteBO, GetMonitorBO, savemonitortBO } from './monitorlist.model';
import { CommonApiService } from 'src/app/commonapiservice';
import { HttpClient } from '@angular/common/http';
@Component({
  selector: 'app-monitorlist',
  templateUrl: './monitorlist.component.html',
  styleUrls: ['./monitorlist.component.scss']
})
export class MonitorlistComponent implements OnInit {
  private onDestroy$: Subject<void> = new Subject<void>();
  ListForm: FormGroup;
  ListType: string;
  public filterSettings: object;
  Deleteid: any;
  isSaveorUpdateBoolean:boolean=false;
  public pageSizes: number[] = [10, 15, 20, 50, 100, 250];
  initialPage: PageSettingsModel;
  @ViewChild('gridList') public gridList: GridComponent;
  public GridList: Observable<DataStateChangeEventArgs>;
  saveListFields: savemonitortBO = new savemonitortBO();
  FilterBo: GetMonitorBO = new GetMonitorBO();
  constructor(public getListService: ListDateService,
    public global: GlobalComponent, private formBuilder: FormBuilder,
    public LService: ListService, public toasterService: ToastrService,
    public CommonAPI: CommonApiService,
    private http: HttpClient,
  ) {
    this.ListForm = this.formBuilder.group({
      colorcode: [' ', Validators.required],
      notes: [' ', Validators.required],
    });
    this.global.checkforlogout();
    this.GridList = CommonAPI;
  }
  // fp:functionpermission=new functionpermission()

  // colors = [
  //   { label: 'Red', value: 'red' },

  //   { label: 'Yellow', value: 'yellow' },
  //   { label: 'Green', value: 'green' },
  //   { label: 'Blue', value: 'blue' },
  //   {label:'Orange',value:'orange'},
  //   {label:'Purple',value:'purple'},
  //   {label:'Black',value:'black'},
  //   {label:'Brown',value:'brown'},
  //   {label:'Neon Green',value:'#00FF00'}
  // ];
    colors = [ ];

  selectedColor: any={ label: '', value: '' }
  
  ngOnInit(): void {
    if (
      (this.global.globalAgencyId == null ||
        this.global.globalAgencyId == undefined ||
        this.global.globalAgencyId == "" ||
        this.global.globalAgencyId == "00000000-0000-0000-0000-000000000000") && (this.global.agencyCode == 'SUPERADMIN')) {
      return;
    }

    this.filterSettings = {
      type: 'Menu',
    };
    this.initialPage = { currentPage: 1, totalRecordsCount: 0, pageCount: 10, pageSize: this.pageSizes[0], pageSizes: this.pageSizes ,};
    console.log("cololov")
    this.getcolorlov();
    this.getListFilter();
  }

    getcolorlov() {
      console.log("cololov");
      debugger
    let url = "api/LOV/getLovDropDown?"
    let params = new URLSearchParams();
    params.append("ListCode", 'MONITORCOLOR');
    this.http.get(url+params).subscribe(
      (data:any) => {
        let colorlist = data;
        colorlist.forEach(data =>{
          data.label = data.lovName;
          data.value = data.lovCode;
        })
        this.colors = colorlist;
      },
      (err) => { }
    );
    
  }


  //.........................................CreateLocationList.............................................
  CreateorUpdateList(data) {
    this.ListType = data;
    if (this.ListType == 'create') {
      this.saveListFields = new savemonitortBO();
      this.ListForm.reset();
    }
  }
  // ................................................dataChangeList..............................................
  public dataChangeList(L): void {
    let val = (L.action.requestType).toString();
    if (val != "filterchoicerequest") {
      if ((L.sorted || []).length) {
        this.FilterBo.orderColumn = L.sorted[0].name;
        this.FilterBo.orderType = L.sorted[0].direction === 'descending' ? 'DESC' : 'ASC';
      }
    }
    if (val == "filtering" && L.action.action != "clearFilter") {
      this.FilterBo.value = L.action.currentFilterObject.value;
      this.FilterBo.field = L.action.currentFilterObject.field;
      this.FilterBo.matchCase = L.action.currentFilterObject.matchCase;
      this.FilterBo.operator = L.action.currentFilterObject.operator;
    }
    else {
      if (val == "filtering" && L.action.action == "clearFilter") {
        this.FilterBo.field = "colorName";
        this.FilterBo.matchCase = false;
        this.FilterBo.operator = "contains";
        this.FilterBo.value = "";
        this.FilterBo.type = "string";
      }
    }
    this.getListFilter();
    if (val == "paging" && L.action.name == "actionBegin") {

    }
  }
  //.........................................onActionList.....................................................
  public onActionList(L) {
    this.FilterBo.currentpageno = this.gridList.pagerModule.pagerObj.currentPage;
    this.FilterBo.pageitem = this.gridList.pagerModule.pagerObj.pageSize;
    if (L.name == "actionBegin" && L.requestType == "filterbeforeopen") {
      this.FilterBo.type = L.columnType
    }
  }
  //...........................................getDetails..........................................
  getDetails(saveBos: any) {
    this.saveListFields = JSON.parse(JSON.stringify(saveBos));

    console.log(saveBos,"saveBos===================");
      
    this.saveListFields.id = saveBos.monitorId
    this.saveListFields.colorcode= saveBos.colorName;
    this.saveListFields.notes= saveBos.colorNotes
    this.selectedColor= {label:saveBos.colorName ,
      value:saveBos.colorCode};
      console.log(saveBos,"saveBos===================");
      
    
    console.log(this.selectedColor?.label,"this.selectedColor.label");
  }
  //.........................................Refresh.............................................
  clearlist(type: string) {
    this.ListType = null;
    this.saveListFields = new savemonitortBO();
    this.ListForm.reset();
    if (type == "refresh") {
      this.getListFilter();
    }
  }
  //.........................................getListFilter.............................................
  getListFilter() {
    // this.FilterBo.agencyId = this.global.globalAgencyId;
    let url = "api/Agency/getAgencyColorNotes"
    let responseData =
    {
      result: "result",
      count: "count",
    }
    this.CommonAPI.outputValues(url, this.FilterBo, responseData, "");

    // this.getListService.execute(this.FilterBo);
    let count = 0;
    this.GridList.pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      count = count + 1;
      if (data != null && data.result.length > 15) {
        this.gridList.height = '500';
      }
      else {
        this.gridList.height = 'auto';
      }
    })
  }
   colorChanged(event:any) {
    this.saveListFields.colorcode = event.value;
  }
  //.........................................SaveOrUpdateList.............................................
  SaveOrUpdateList() {
    this.isSaveorUpdateBoolean=true;
    let saveListitems: ColorNoteBO = new ColorNoteBO();
    console.log(this.selectedColor.label,"this.selectedColor.label");
    
    let savelist = JSON.parse(JSON.stringify(this.saveListFields));
    saveListitems.colorName = this.selectedColor.label;
    saveListitems.colorNotes =savelist.notes;
    saveListitems.colorCode = this.selectedColor.value
    console.log(saveListitems, "saveListitems=======");

    let url = "api/Agency/SaveUpdateColorNote"
    saveListitems.monitorId = this.saveListFields.id;
    // if (this.saveListFields.isAvailableToAgency == null || this.saveListFields.isAvailableToAgency == undefined || this.saveListFields.isAvailableToAgency == false) {
    //   saveListitems.isAvailableToAgency = false;
    // }
    this.CommonAPI.saveorUpdateFunctionwithResponseTypeJson(saveListitems, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.isSaveorUpdateBoolean=false;
      if (data) {
        if (this.ListType == 'create') {
          this.toasterService.success('List saved successfully!');
          setTimeout(() => {
            this.toasterService.clear();
          }, 8000);

        }
        else if (this.ListType == 'update') {
          this.toasterService.success('List updated successfully!');
          setTimeout(() => {
            this.toasterService.clear();
          }, 8000);
        }
        document.getElementById('openListModal').click();
        this.ListForm.reset();
        this.FilterBo = new GetMonitorBO();
        this.saveListFields = new savemonitortBO();
        this.getListFilter();
      }
    }, (err: any) => {
      this.isSaveorUpdateBoolean=false;
      if (err) {
        this.toasterService.error(err, 'Error'), 8000;
      }
    })
  }
  //.....................................showLocationColumns....................................
  showLocationColumns() {
    this.gridList.columnChooserModule.openColumnChooser(200, 50);
  }
  setDeleteid(data) {
    this.Deleteid = data;
  }
  //..........................................DeleteLocation...........................................................
  DeleteList() {
    let params = new URLSearchParams();
    params.append("Id", this.saveListFields.id);
    let url = "api/Agency/DelteColorNote?";
    this.CommonAPI.DeleteFunctionForDeleteHttp(params,url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
     this.toasterService.success('List deleted successfully!');
      setTimeout(() => {
        this.toasterService.clear();
      }, 8000);
      this.saveListFields = new savemonitortBO();
      this.FilterBo = new GetMonitorBO();
      document.getElementById('closeListModal').click();
      this.getListFilter();
    }, (err: any) => {
      if (err) {
        this.toasterService.error(err, 'Error'), 8000;
      }
    });


  }
  public ngOnDestroy(): void {
    this.onDestroy$.next();
  }

}
